import React from "react";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItemText from "@material-ui/core/ListItemText";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Drawer from "@mui/material/Drawer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AvatarIcon from "../assets/icons/avatar.svg";
import Divider from "@mui/material/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AddCardIcon from '@mui/icons-material/AddCard';
import AliceCarousel from "react-alice-carousel";
import {MarketComponent} from "./MarketComponent";
import {TabPanel} from "./TabPanelComponent";
import {Link} from "react-router-dom";
import {AVATAR_BASE_URL_API, BANNER_BASE_URL_API, BASE_URL, BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {BasketComponent} from "./BasketComponent";
import Typography from "@material-ui/core/Typography";
import {Grid} from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import {styled} from "@mui/material/styles";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import Paper from "@material-ui/core/Paper";
import { FormPropsTextFields} from './HookUtils'
import Box from "@material-ui/core/Box";
import "react-alice-carousel/lib/alice-carousel.css";
const drawerWidth = 240;
const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


export class ToolbarComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fetchedCategories: [],
            cardShopCount: 0,
            userData: null,
            banners: [],
            value: 0,
            open: false,
        }

    }


    componentDidMount() {

        this.setState({cardShopCount: CardShopRepository.getAll() !== null ? CardShopRepository.getAll().length : 0})
        fetch(BASE_URL_API + 'category', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    this.setState({fetchedCategories: results.data})

                },
                (error) => {
                    console.log("error")

                }
            );


        fetch(BASE_URL_API + 'banner?type=home')
            .then(response => response.json())
            .then(results => {
                    this.setState({banners: results.data})

                },
                (error) => {
                    console.log("error")

                }
            );

        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data})
                    }


                },
                (error) => {
                    console.log("error")

                }
            );
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue})
    };

    handleDrawerClose = () => {
        this.setState({open: false})
    };

    handleDrawerOpen = () => {
        this.setState({open: true})
    };

    render() {


        if (localStorage.getItem("pwa_token") === null) {
            window.location.assign(BASE_URL + 'verify');
        }

        let drawerOptionLinks = ['/transaction', '/order', "/about-us", "/privacy-policy"];
        return <React.Fragment key={"toolbar"}>

            <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                <ToolbarMui>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        onClick={this.handleDrawerOpen}
                        sx={{...(this.state.open && {display: 'none'})}}>
                        <MenuIcon  style={{ color: 'black' }}/>

                    </IconButton>

                    <ListItemText style={{width: '90%', color: 'black'}} align="center"><strong style={{
                        fontSize: 18,
                        overflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: 'black'
                    }} >{"Hamekara"}</strong></ListItemText>
                    <IconButton  component={Link} to={"/search"} style={{ color: 'black' }}><SearchIcon/></IconButton>


                    <IconButton  style={{ color: 'black' }} >  <BasketComponent /></IconButton>


                </ToolbarMui>

                <Tabs
                    key={"tabs"}
                    variant="scrollable"
                    value={this.state.value}
                    onChange={this.handleChange}
                    aria-label="simple tabs example"
                    textColor="secondary"
                    indicatorColor="#2d2d2d"
                    primary="#000000">

                    {this.state.fetchedCategories.map((category) => (
                        <Tab key={category.id} label={category.title}/>
                    ))}

                </Tabs>

            </AppBar>

            <Drawer sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                }
            }}
                    variant="persistent"
                    anchor="right"
                    open={this.state.open}>
                <DrawerHeader>
                    <IconButton onClick={this.handleDrawerClose}>
                        <ChevronRightIcon/>
                    </IconButton>
                    {
                        (this.state.userData === null || this.state.userData.picture === null) ?
                            (<Grid container>
                                <Grid xs={12}>
                                    <img style={{marginRight: 16}} alt="avatar2" src={AvatarIcon}/>
                                    {
                                        this.state.userData !== null ? <Typography style={{
                                            fontWeight: 'bold',
                                            fontSize: 18,
                                            marginBottom: 18,
                                            marginRight: 16,
                                            color: 'green',
                                        }}>{this.state.userData.name}</Typography> : ""
                                    }

                                </Grid>

                                {
                                    this.state.userData !== null ?
                                        <React.Fragment>
                                            <Grid xs={2}>
                                                <PhoneIphoneIcon/>
                                            </Grid>
                                            <Grid xs={10}>

                                                <Typography key={this.state.userData.phone} style={{
                                                    fontSize: 14,
                                                    color: 'gray',
                                                }} align='right'>{this.state.userData.phone}
                                                </Typography>
                                            </Grid>

                                            <Grid xs={2}>
                                                <AddCardIcon/>
                                            </Grid>
                                            <Grid xs={10}>

                                                <Typography key={this.state.userData.wallet} style={{
                                                    fontSize: 14,
                                                    color: 'gray'
                                                }} align='right'>
                                                    {this.state.userData.wallet}
                                                </Typography>

                                            </Grid>
                                        </React.Fragment>
                                        : ""

                                }

                            </Grid>) : (
                                <Grid container>
                                    <Grid xs={12}>
                                        <img style={{marginRight: 16}} alt="avatar2"
                                             src={`${AVATAR_BASE_URL_API}${this.state.userData.picture.url}`}/>
                                        <Typography style={{
                                            fontWeight: 'bold',
                                            fontSize: 18,
                                            marginBottom: 18,
                                            marginRight: 16,
                                            color: 'green',
                                        }}>{this.state.userData.name}</Typography>
                                    </Grid>

                                    <Grid xs={2}>
                                        <PhoneIphoneIcon/>
                                    </Grid>
                                    <Grid xs={10}>

                                        <Typography key={this.state.userData.phone} style={{
                                            fontSize: 14,
                                            color: 'gray',
                                        }} align='right'>{this.state.userData.phone}
                                        </Typography>
                                    </Grid>

                                    <Grid xs={2}>
                                        <AddCardIcon/>
                                    </Grid>
                                    <Grid xs={10}>

                                        <Typography key={this.state.userData.wallet} style={{
                                            fontSize: 14,
                                            color: 'gray'
                                        }} align='right'>
                                            {this.state.userData.wallet}
                                        </Typography>

                                    </Grid>


                                </Grid>
                            )

                    }


                </DrawerHeader>

                <Divider style={{marginTop: 50}}/>


                <List>
                    {['سوابق تراکنش', 'سفارشات', 'درباره ما', 'قوانین و مقررات'].map((text, index) => (
                        <ListItem button key={text} component={Link}
                                  to={drawerOptionLinks[index]}>
                            <ListItemIcon>
                                {index === 0 ? <PendingActionsOutlinedIcon/> : ""}
                                {index === 1 ? <ShoppingBasketOutlinedIcon/> : ""}
                                {index === 2 ? <ReduceCapacityOutlinedIcon/> : ""}
                                {index === 3 ? <PrivacyTipOutlinedIcon/> : ""}
                            </ListItemIcon>
                            <ListItemText align='right'>{text}</ListItemText>
                        </ListItem>
                    ))}
                </List>

                <Divider/>

            </Drawer>

            {this.state.fetchedCategories.map((category, index) => (
                <React.Fragment>
                    <TabPanel style={{width: '100%'}} key={category.id} value={this.state.value} index={index}>
                        <AliceCarousel autoPlay
                                       autoPlayStrategy="none"
                                       autoPlayInterval={2500}
                                       animationDuration={1000}
                                       infinite
                                       touchTracking={false}
                                       fadeOutAnimation={true}
                                       disableButtonsControls>
                            {this.state.banners.map((banner, index) => (

                                <div    align='center'>
                                        <img style={{   marginTop: 90,height:300,width:'80%', objectFit: 'contain'}} src={( BANNER_BASE_URL_API + banner.picture.url )}/>
                                </div>



                            ))}
                        </AliceCarousel>

                        <MarketComponent key={category.id} parent_category_id={category.id}/>
                    </TabPanel>
                </React.Fragment>

            ))}


            <FormPropsTextFields/>
        </React.Fragment>;

    }
}
